import { Component, OnInit } from "@angular/core";
import { DocumentacionService } from "./documentacion.service";
import { RegistroDocumentacion } from "../Modelos/RegistroDocumentacion";
import { Parametro, PolizaService } from "../poliza/poliza.service";
import { ArchivoASubir } from "../Modelos/ArchivoASubir";
import { Pagina } from "../Modelos/Pagina";
import { environment } from "src/environments/environment";

declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let inicializarModales: Function;
declare let mostrarToast: Function;
declare let abrirModal: Function;
declare let cerrarModal: Function;
declare let limpiarValor: Function;
declare let convertirAFecha: Function;
declare let obtenerFecha: Function;
declare let renderizarDatePickers: Function;
declare let descargarBase64: Function;
declare let formatearFecha: Function;

@Component({
    templateUrl: "documentacion.component.html",
    selector: "documentacion",
    styleUrls: ["documentacion.component.css"]
})
export class DocumentacionComponent implements OnInit{

    constructor(private documentacionService: DocumentacionService, private polizaService: PolizaService){}

    resultadoRegistros: RegistroDocumentacion[];
    listaRegistros: RegistroDocumentacion[];
    filtrados: RegistroDocumentacion[];
    registrosPorPagina: number;
    pagina: number;
    ramos: any[];
    agencias: any[];
    agenciasFiltro: any[];
    estados: any[];
    ordenActual: string;
    documentoASubir: RegistroDocumentacion;
    paginacion: Pagina[];

    filtro: string;
    agenciaFiltro: number;
    estadoFiltro: number;
    fechaDesdeFiltro: string;
    fechaHastaFiltro: string;

    esDocumentoConsolidado: boolean;
    documentosIndividuales: any[];
    documentoConsolidado: any;
    flagDocumentosIndividuales: boolean;
    flagDocumentoConsolidado: boolean;

    cod_suc: string;
    cod_agt: string;
    cod_tagt: string;

    async ngOnInit(){
        mostrarLoader();
        this.cod_suc = sessionStorage.getItem('cod_suc');
        this.cod_agt = sessionStorage.getItem('cod_agt');
        this.cod_tagt = sessionStorage.getItem('cod_tagt');

        this.cod_suc = this.cod_suc ? this.cod_suc : '0';
        this.cod_agt = this.cod_agt ? this.cod_agt : '0';
        this.cod_tagt = this.cod_tagt ? this.cod_tagt : '0'

        this.registrosPorPagina=10;
        this.pagina=0;
        this.listaRegistros=[];
        this.filtrados=[];

        this.filtro="";
        this.agenciaFiltro==null;
        this.estadoFiltro=2;
        this.fechaDesdeFiltro="";
        this.fechaHastaFiltro="";

        this.ramos=await this.polizaService.consultarRamos();
        this.agencias=await this.polizaService.consultarAgencias();
        await this.cargarAgenciasFiltro();
        this.estados=[{codigo_estado: 1, nombre: "Con documentación"}, {codigo_estado: 2, nombre: "Sin documentación"}]


        this.esDocumentoConsolidado=false;

        await this.consultarRegistrosDocumentacion();
        this.inicializarPaginacion();
        this.filtrar();
        inicializarModales();
        renderizarDatePickers();
        ocultarLoader();
    }

    async cargarAgenciasFiltro(){
        let parametrosAgencias: Parametro[]=[
            {llave: "cod_sucursal", valor: this.cod_suc ? this.cod_suc : '0'},
            {llave: "cod_agente", valor: this.cod_agt ? this.cod_agt : '0' },
            {llave: "cod_tipo_agente", valor: this.cod_tagt ? this.cod_tagt : '0'},
            {llave: "Cod_UsuarioSISE", valor:  sessionStorage.getItem("codusuariosise") ?  sessionStorage.getItem("codusuariosise") : '0'}
        ];

        let result=await (this.polizaService.consultarAgencias(true, parametrosAgencias));

        let agenciasResult = result.map(element => {return {codigo_agencia: element.codigoSucursal, nombre: element.nombreSucursal}});

        this.agenciasFiltro=[...agenciasResult];
        if(this.cod_suc != "800"){
            this.agenciaFiltro = this.agenciasFiltro[0].codigo_agencia;
        }     
    }

    async consultarRegistrosDocumentacion(documentacionCargada: boolean=false) {
        const parametro = this.cod_suc === "800" ? 800 : this.agenciaFiltro;
        let resultados=
            (documentacionCargada)
            ? (await this.documentacionService.consultarDocumentacionCargada(parametro, parseInt(this.cod_agt)))
            :(await this.documentacionService.consultarDocumentacion(parametro, parseInt(this.cod_agt)));

            console.log("resultados documentacion ", resultados);
        resultados=resultados.map(registro => {
            let fechaEmision: Date=new Date(registro.fecha_emision);
            return new RegistroDocumentacion(
                registro.cod_sucursal,
                this.agencias.find(x => x.codigo_agencia==registro.cod_sucursal).nombre,
                registro.cod_ramo,
                this.ramos.find(x => x.codigo_ramo==registro.cod_ramo).nombre,
                registro.nro_poliza,
                registro.nro_documento,
                registro.apellido,
                fechaEmision.toLocaleDateString("es-CO", {}),
                registro.dias,
                (registro.color)?registro.color.toLowerCase():"",
                registro.cod_proceso,
                documentacionCargada
            );
        });
        this.resultadoRegistros=resultados;
    }

    async mostrarResultados(){
        this.listaRegistros=[];
        let inicio=(this.registrosPorPagina*this.pagina), fin=(this.registrosPorPagina*this.pagina)+this.registrosPorPagina;

        if(fin>this.resultadoRegistros.length-1)
            fin=this.resultadoRegistros.length;

        for(let i=inicio; i<fin; i++){
            if(this.filtrados[i])
                this.listaRegistros.push(this.filtrados[i]);
        };
    }

    inicializarPaginacion(){
        this.paginacion=[];
        this.paginacion.push({valor: -10, texto: "", disabled: false, activo: false, visible: false});
        this.paginacion.push({valor: 0, texto: "1", disabled: false, activo: true,  visible: true});
        this.paginacion.push({valor: 1, texto: "2", disabled: false, activo: false, visible: true});
        this.paginacion.push({valor: 2, texto: "3", disabled: false, activo: false, visible: true});
        this.paginacion.push({valor: 3, texto: "4", disabled: false, activo: false, visible: true});
        this.paginacion.push({valor: -1, texto: "", disabled: false, activo: false, visible: true});
    }

    cambiarPagina(pagina: Pagina){
        mostrarLoader();

        let paginaMaxima=Math.ceil(this.filtrados.length/this.registrosPorPagina)-1;

        if(pagina==null){
            this.pagina=(paginaMaxima==-1)?-1:0;
            this.inicializarPaginacion();
        }
        else if(pagina.valor==-10)
            this.pagina--;
        else if(pagina.valor==-1)
            this.pagina++;
        else
            this.pagina=Object.create(pagina).valor;

        if(this.pagina==this.paginacion[4].valor && this.pagina<paginaMaxima){
            this.paginacion[1]={valor: this.pagina-2, texto: (this.pagina-1).toString(), activo:false, disabled: false, visible: true};
            this.paginacion[2]={valor: this.pagina-1, texto: (this.pagina).toString(), activo:false, disabled: false, visible: true};
            this.paginacion[3]={valor: this.pagina, texto: (this.pagina+1).toString(), activo:true, disabled: false, visible: true};
            this.paginacion[4]={valor: this.pagina+1, texto: (this.pagina+2).toString(), activo:false, disabled: false, visible: true};
        }
        else if(this.pagina==this.paginacion[1].valor && this.pagina>0){
            this.paginacion[1]={valor: this.pagina-1, texto: (this.pagina).toString(), activo:false, disabled: false, visible: true};
            this.paginacion[2]={valor: this.pagina, texto: (this.pagina+1).toString(), activo:false, disabled: false, visible: true};
            this.paginacion[3]={valor: this.pagina+1, texto: (this.pagina+2).toString(), activo:false, disabled: false, visible: true};
            this.paginacion[4]={valor: this.pagina+2, texto: (this.pagina+3).toString(), activo:true, disabled: false, visible: true};
        }

        this.paginacion[0].visible=(this.pagina>0);
        this.paginacion[1].visible=(this.paginacion[1].valor<=paginaMaxima);
        this.paginacion[2].visible=(this.paginacion[2].valor<=paginaMaxima);
        this.paginacion[3].visible=(this.paginacion[3].valor<=paginaMaxima);
        this.paginacion[4].visible=(this.paginacion[4].valor<=paginaMaxima);
        this.paginacion[5].visible=!(this.pagina==paginaMaxima);

        this.paginacion.forEach(x=>x.activo=(x.valor==this.pagina));
        this.mostrarResultados();
        ocultarLoader();
    }

    ordenar(columna: string){
        mostrarLoader();
        if(columna!=this.ordenActual){
            if(columna=="fechaEmision")
                this.filtrados=this.filtrados.sort((a, b) => (convertirAFecha(a[columna]) > convertirAFecha(b[columna])) ? 1 : ((convertirAFecha(b[columna]) > convertirAFecha(a[columna])) ? -1 : 0));
            else
                this.filtrados=this.filtrados.sort((a, b) => (a[columna] > b[columna]) ? 1 : ((b[columna] > a[columna]) ? -1 : 0));
            this.ordenActual=columna;
        }
        else{
            if(columna=="fechaEmision")
                this.filtrados=this.filtrados.sort((a, b) => (convertirAFecha(a[columna]) < convertirAFecha(b[columna])) ? 1 : ((convertirAFecha(b[columna]) < convertirAFecha(a[columna])) ? -1 : 0));
            else
                this.filtrados=this.filtrados.sort((a, b) => (a[columna] < b[columna]) ? 1 : ((b[columna] < a[columna]) ? -1 : 0));
            this.ordenActual=columna+" desc";
        }
        this.mostrarResultados();
        ocultarLoader();
    }

    cargarArchivo(event, codigoDocumento: number=9){
        mostrarLoader();
        let file = event.target.files[0];
        let archivoASubir: ArchivoASubir=new ArchivoASubir();
        let array=(file.name.split("."));
        archivoASubir.extension=array[array.length-1].toLowerCase();

        let archivosPermitidos=(codigoDocumento==9)?["zip", "pdf"]:["docx", "pdf", "png", "jpg", "jpeg", "xls", "xlsx"];
        if(!archivosPermitidos.includes(archivoASubir.extension)){
            let idInput=(codigoDocumento==9)?"archivoUnificado":("archivoIndividual"+codigoDocumento);
            limpiarValor(idInput);
            mostrarToast("El formato de archivo no es permitido");
        }
        else{
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                archivoASubir.valor=reader.result.toString();
                archivoASubir.codigo=codigoDocumento;
                let resultadoGuardado=await this.guardarDocumentacion(archivoASubir);
                if(codigoDocumento==9){
                    if(resultadoGuardado==true){
                        this.cerrarModalCargarDocumentos();
                        mostrarToast("Documentación cargada correctamente.");
                        this.ngOnInit();
                    }
                }
                else{
                    if(resultadoGuardado)
                        mostrarToast("Documento cargado correctamente.");
                    await this.cargarDocumentosIndividuales();
                    this.verificarDocumentosIndividuales();
                }
                ocultarLoader();
            }
        }
    }

    async guardarDocumentacion(archivoASubir: ArchivoASubir){
        if(archivoASubir){
            let respuesta=await this.documentacionService.guardarDocumentacion(this.documentoASubir, archivoASubir, sessionStorage.getItem("codusuariosise"));
            if(respuesta==false || respuesta.hasOwnProperty("status")){
                mostrarToast("No se ha podido cargar la documentación.");
                return false;
            }
            return true;
        }
    }

    async abrirModalCargarDocumentos(registro: RegistroDocumentacion){
        const payload = {
            Cedula: registro.numeroDocumento,
            CodigoProceso: registro.codigoProceso,
            CodigoRamo: registro.codigoRamo,
            CodigoSucursal: registro.codigoSucursal,
            Poliza: registro.numeroPoliza,
            Usuario: sessionStorage.getItem("codusuariosise"),
        };
        const response = await this.documentacionService.finlecoToCumplimiento(payload);

        this.documentoASubir=registro;
        let documentosCargados=await this.documentacionService.consultarDocumentosPorRamoCargados(registro.codigoRamo, registro.codigoProceso);
        if(registro.documentacionCargada && documentosCargados.filter(x => x.codigo_documento==9).length>0){
            this.documentoConsolidado=documentosCargados.filter(x => x.codigo_documento==9)[0];
            this.esDocumentoConsolidado=true;
            this.flagDocumentoConsolidado=true;
            this.documentosIndividuales=[];
        }
        else{
            await this.cargarDocumentosIndividuales();
            this.flagDocumentoConsolidado=false;
        }
        this.verificarDocumentosIndividuales();
        abrirModal("modalCargarDocumentos", false);
    }

    async cargarDocumentosIndividuales(){
        let documentosCargados=await this.documentacionService.consultarDocumentosPorRamoCargados(this.documentoASubir.codigoRamo, this.documentoASubir.codigoProceso);
        this.documentosIndividuales=await this.documentacionService.consultarDocumentosPorRamo(this.documentoASubir.codigoRamo, this.documentoASubir.codigoProceso);
        this.documentosIndividuales=this.documentosIndividuales.filter(x => x.codigo_documento!=9);
        documentosCargados.forEach( x => {
            let documento=this.documentosIndividuales.find(y=>y.codigo_documento==x.codigo_documento);
            documento.ruta=x.ruta;
        });
    }

    verificarDocumentosIndividuales(){
        this.flagDocumentosIndividuales=false;
        let contadorDocumentosCargados=0;
        this.documentosIndividuales.forEach(x => contadorDocumentosCargados += (x.ruta.length>0) ? 1 : 0);
        if(contadorDocumentosCargados>0){
            this.esDocumentoConsolidado=false;
            this.flagDocumentosIndividuales=true;
        }
        if(contadorDocumentosCargados==this.documentosIndividuales.length && !this.documentoASubir.documentacionCargada){
            this.cerrarModalCargarDocumentos();
            mostrarToast("Documentación cargada correctamente.");
            this.ngOnInit();
        }
    }

    formatearFecha(fecha){
        this.fechaDesdeFiltro = formatearFecha(this[fecha]);
    }

    obtenerFechaDesde(){
        let fechaDesde=obtenerFecha("FechaDesdeFiltro");
        this.fechaDesdeFiltro=fechaDesde.toLocaleString("es-CO", {});
        this.filtrar();
    }

    obtenerFechaHasta(){
        let fechaHasta: Date=obtenerFecha("FechaHastaFiltro");
        this.fechaHastaFiltro=fechaHasta.toLocaleString("es-CO", {});
        this.filtrar();
    }

    filtrar(){
        this.filtro=(!this.filtro)?"":this.filtro.toString().replace(/\D/g, '');
        if(this.filtro.length>=12)
            this.filtro = this.filtro.slice(0, 12);

        this.filtrados=this.resultadoRegistros.filter(x =>
            x.numeroPoliza.toString().includes(this.filtro) ||
            x.numeroDocumento.toString().includes(this.filtro));


        var agencias_validas = this.agenciasFiltro.map(x => x.codigo_agencia);    

        if(this.agenciaFiltro)
            this.filtrados=this.filtrados.filter(x => x.codigoSucursal==this.agenciaFiltro);

        if(this.fechaDesdeFiltro.length>0){
            let fechaDesde=convertirAFecha(this.fechaDesdeFiltro);
            this.filtrados=this.filtrados.filter(x => convertirAFecha(x.fechaEmision)>=fechaDesde);
        }

        if(this.fechaHastaFiltro.length>0){
            let fechaHasta=convertirAFecha(this.fechaHastaFiltro);
            this.filtrados=this.filtrados.filter(x => convertirAFecha(x.fechaEmision)<=fechaHasta);
        }
        this.cambiarPagina(null);
    }

    async filtrarEstados(){
        await this.consultarRegistrosDocumentacion((this.estadoFiltro==1));
        this.filtrar();
    }

    async descargarArchivo(documento){
        mostrarLoader();

        if(!documento)
            documento=this.documentoConsolidado;

        let base64=await this.documentacionService.obtenerBase64DesdeRuta(documento.ruta);
        let array=documento.ruta.split("\\");
        let encabezado=await this.documentacionService.obtenerEncabezado(this.documentoASubir.codigoRamo, this.documentoASubir.codigoProceso, documento.codigo_documento)
        descargarBase64(`${encabezado},${base64}`, array[array.length-1]);
        ocultarLoader();
    }

    async cerrarModalCargarDocumentos(){
        await this.consultarRegistrosDocumentacion(this.estadoFiltro==1);
        this.filtrar();
        limpiarValor("archivoUnificado");
        cerrarModal("modalCargarDocumentos");
    }
}
